import { string } from '@/shared/libs/yup';
import { HookFormField, FieldTextareaProps } from '@/shared/libs/hook-form';

export const helpMessageSchema = string().label('Message');

export const HelpMessageHookFormField = (props: FieldTextareaProps) => <HookFormField.Textarea label="Message" {...props}/>;